export const environment = {
  production: true,
  buildId: '4161399569824911',
  configFile: 'config.json',
};
